import { Environment } from '@core/models/environment.model';

export const environment: Environment = {
  production: true,
  financialPlanner: {
    url: 'https://e066atr1i0.execute-api.eu-west-1.amazonaws.com/v1_0'
  },
  scorings: {
    url: 'https://xarjeq51re.execute-api.eu-west-1.amazonaws.com/pro'
  },
  recaptcha: {
    siteKey: '6LcuuNcaAAAAAHrsBOwHIXSz3RaPGu_vsvU1BkyI'
  }
};
